module.exports = __webpack_public_path__ + "static/media/confcp_107.47413460.ico";